module.exports = __webpack_public_path__ + "assets/7dc0e7c1436f3a04e51d3e833c0eec99.png";